import axios from 'axios'
import { BASE_URL } from '../../constants/config'


async function getOrder(token, orderId) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/admin/order/${orderId}`
    }
    return axios(options)
}

async function memberListOrders(token, userId, limit, skip, search) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            limit,
            skip,
            search
        },
        url: `${BASE_URL}/admin/user/${userId}/order`
    }
    return axios(options)
}

async function listOrders(token, limit, skip, search) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            limit,
            skip,
            search
        },
        url: `${BASE_URL}/admin/order`
    }
    return axios(options)
}

async function updateOrderStatus(token, orderId, status) {
    const options = {
        method: 'put',
        headers: {
            'Authorization': `JWT ${token}`
        },
        data: {
            status
        },
        url: `${BASE_URL}/admin/order/${orderId}`
    }
    return axios(options)
}

async function updateReservationStatus(token, orderId, reservationId, status) {
    const options = {
        method: 'put',
        headers: {
            'Authorization': `JWT ${token}`
        },
        data: {
            status
        },
        url: `${BASE_URL}/admin/order/${orderId}/reservation/${reservationId}`
    }
    return axios(options)
}

export default {
    getOrder,
    memberListOrders,
    listOrders,
    updateOrderStatus,
    updateReservationStatus
}